export default __webpack_public_path__ + "src/images/packages/the-african-renaissance/22baf11e26cdfb89393033d1fe7e22f7-3.jpg";